import { useClick, useRole, useDismiss, useListNavigation, useInteractions } from '@floating-ui/react';
export const useDropdownInteractions = (context, activeIndex, listItems, selectedIndex, handleActiveIndexChange, {
  searchable
}) => {
  const click = useClick(context, {
    toggle: !searchable
  });
  const role = useRole(context, {
    role: 'listbox'
  });
  const dismiss = useDismiss(context);
  const listNavigation = useListNavigation(context, {
    listRef: listItems,
    activeIndex,
    selectedIndex,
    onNavigate: handleActiveIndexChange,
    virtual: true
  });
  return useInteractions([click, role, dismiss, listNavigation]);
};